import { Label, Row } from '@ydistri/ds';
import React, { useCallback } from 'react';
import { Segmented, SegmentedProps } from 'antd';

const defaultSortingOptions: SegmentedProps<string>['options'] = [
  {
    label: 'Most recent',
    value: 'LastUpdatedAt',
  },
  {
    label: 'A-Z (Name)',
    value: 'Name',
  },
];

interface SortSelectorProps {
  defaultValue?: string;
  sortingOptions?: SegmentedProps<string>['options'];
  onSortChange: (s: string) => void;
}

/**
 * Control to select the sorting of items
 * @param defaultValue Default selected value
 * @param sortingOptions Sorting options to display (default: Most recent, A-Z)
 * @param onSortChange Callback when the sorting is changed
 * @constructor
 */
const SortSelector: React.FC<SortSelectorProps> = ({
  defaultValue,
  sortingOptions = defaultSortingOptions,
  onSortChange,
}) => {
  const [value, setValue] = React.useState(defaultValue ?? 'CreatedAt');

  const onChangeHandler = useCallback(
    (v: string) => {
      setValue(v);
      onSortChange(v);
    },
    [onSortChange],
  );

  return (
    <Row $gap="1rem" $alignItems="center">
      <Label>Sort by: </Label>{' '}
      <Segmented options={sortingOptions} value={value} onChange={onChangeHandler} />
    </Row>
  );
};

export default SortSelector;
